import React, { forwardRef, useRef, useState } from "react";
import ComponentCustomModal from "../../components/common/customModal/ComponentCustomModal";
import QRCode from "qrcode.react";
import useISPowner from "../../hooks/useISPOwner";
import { useTranslation } from "react-i18next";
import ReactToPrint from "react-to-print";

const PrintVoucher = ({ show, setShow, vouchers }) => {
  const { t } = useTranslation();
  const componentRef = useRef();

  //---> Local State
  const [open, setOpen] = useState(false);

  //---> Get user & current user data form useISPOwner hooks
  const { ispOwnerData } = useISPowner();

  const codeUrl = `https://app.netfeebd.com/isp/hotspot/${ispOwnerData.netFeeId}`;

  const VoucherPrint = forwardRef((props, ref) => (
    <div ref={ref} className="displayGrid2">
      {vouchers?.map((value) => (
        <div className="gridTemplateManualColumn2_8">
          <div className="voucher-vertical-price-session">
            <div class="voucher-vertical-price-pdf">৳{value?.monthlyFee}</div>
            <div className="voucher-code-pdf">{value?.customerId}</div>
            <QRCode
              id="qr-gen"
              value={codeUrl}
              size={40}
              level="H"
              includeMargin={false}
              bgColor="#2F6BB9"
              fgColor="#fff"
            />
          </div>
          <div className="d-flex flex-column justify-content-between">
            <div>
              <div className="voucher-vertical-header-session">
                <div class="voucher-vertical-header-pdf">
                  {ispOwnerData?.company}
                </div>
              </div>
              <div className="voucher-vertical-body-session">
                <p className="displayGridManual3_7 px-2 mt-0 voucher-vertical-username">
                  <span>Username: </span>
                  <span>{value?.hotspot?.name}</span>
                </p>
                <hr className="mt-0 mb-1" />

                <p className="voucher-vertical-passwod">
                  {value?.hotspot?.password}
                </p>
              </div>
            </div>

            <div className="mt-1">
              <div className="voucher-vertical-session">
                This voucher is valid for 30 days from activation on 2 devices.
              </div>

              <strong className="voucher-vertical-footer-pdf">
                Thank you!
              </strong>
            </div>
          </div>
        </div>
      ))}
    </div>
  ));

  return (
    <ComponentCustomModal
      show={show}
      setShow={setShow}
      size="lg"
      centered={true}
    >
      <div className="displayGrid2">
        <div class="">
          <div class="voucher-header">Demo Internet Service Provider</div>

          <div class="price-section">
            <div class="price-value d-flex justify-content-between align-items-center">
              <p className="fs-6">
                <small class="text-black opacity-50">username</small>
                <p>icoeI9w2</p>
              </p>
              <span>৳20</span>
            </div>
            <div class="d-flex justify-content-center">
              <span className="price-label">93idJOjeLo</span>
            </div>
          </div>

          <div class="footer-note">
            <strong>Thank you!</strong> This voucher is valid for 30 days from
            activation on 2 devices.
          </div>
        </div>

        <div className="gridTemplateManualColumn3_7">
          <div className="voucher-vertical-price-session">
            <div class="voucher-vertical-price">৳20</div>
            <div className="voucher-code">VCH-2025-119112</div>
            <QRCode
              id="qr-gen"
              value={codeUrl}
              size={70}
              level="H"
              includeMargin={false}
              bgColor="#2F6BB9"
              fgColor="#fff"
            />
          </div>
          <div className="d-flex flex-column justify-content-between">
            <div>
              <div className="voucher-vertical-header-session">
                <div class="voucher-vertical-header">Demo Internet Service</div>
              </div>
              <div className="voucher-vertical-body-session">
                <p className="displayGridManual3_7 px-2">
                  <span>Username </span>
                  <span>4ur394ruf9</span>
                </p>
                <hr className="mt-0" />

                <p className="voucher-vertical-passwod">93idJOjeLo</p>
              </div>
            </div>

            <div>
              <div className="voucher-vertical-session">
                This voucher is valid for 30 days from activation on 2 devices.
              </div>

              <strong className="voucher-vertical-footer">Thank you!</strong>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="displayGrid1 float-end mt-4">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setShow(false)}
          >
            {t("cancel")}
          </button>

          <div onClick={() => setOpen(true)}>
            <ReactToPrint
              documentTitle={t("print")}
              trigger={() => (
                <button className="btn btn-success customBtn">
                  {t("print")}
                </button>
              )}
              content={() => componentRef.current}
            />
          </div>
        </div>
      </div>

      {open && <VoucherPrint ref={componentRef} />}
    </ComponentCustomModal>
  );
};

export default PrintVoucher;
